import { Box, Container, Typography, Grid, Link, IconButton, Divider } from '@mui/material';
import FacebookIcon from '@mui/icons-material/Facebook';
import EmailIcon from '@mui/icons-material/Email';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { Link as RouterLink } from 'react-router-dom';
import { motion } from 'framer-motion';
import ContactCard from '../common/ContactCard';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  
  return (
    <Box sx={{ bgcolor: 'primary.main', color: 'white', pt: 6, pb: 4, mt: 'auto', position: 'relative' }}>
      {/* Scroll to top button */}
      <Box 
        sx={{ 
          position: 'absolute', 
          top: -25, 
          left: '50%', 
          transform: 'translateX(-50%)',
          zIndex: 10
        }}
      >
        <IconButton 
          onClick={scrollToTop}
          sx={{ 
            bgcolor: 'white', 
            color: 'primary.main',
            boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
            '&:hover': {
              bgcolor: 'white',
              transform: 'translateY(-3px)',
              boxShadow: '0 4px 15px rgba(0,0,0,0.15)',
            },
            transition: 'all 0.3s ease'
          }}
          component={motion.button}
          whileHover={{ y: -3 }}
        >
          <KeyboardArrowUpIcon />
        </IconButton>
      </Box>
      
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          <Grid item xs={12} sm={4}>
            <Typography variant="h6" gutterBottom fontWeight="medium">
              Brynleigh Estates
            </Typography>
            <Typography variant="body2" sx={{ mb: 2, opacity: 0.9 }}>
              A premier residential community located in Chelsea, Alabama in Shelby County.
            </Typography>
            <Box sx={{ mt: 2, display: 'flex', gap: 1 }}>
              <IconButton 
                href="http://www.facebook.com/groups/BrynleighEstatesResidents" 
                target="_blank"
                sx={{ 
                  color: 'white', 
                  bgcolor: 'rgba(255,255,255,0.1)',
                  '&:hover': {
                    bgcolor: 'rgba(255,255,255,0.2)',
                  }
                }}
                size="small"
              >
                <FacebookIcon fontSize="small" />
              </IconButton>
              <IconButton 
                component={RouterLink} 
                to="/contacts"
                sx={{ 
                  color: 'white', 
                  bgcolor: 'rgba(255,255,255,0.1)',
                  '&:hover': {
                    bgcolor: 'rgba(255,255,255,0.2)',
                  }
                }}
                size="small"
              >
                <EmailIcon fontSize="small" />
              </IconButton>
            </Box>
          </Grid>
          
          <Grid item xs={12} sm={4}>
            <Typography variant="h6" gutterBottom fontWeight="medium">
              Quick Links
            </Typography>
            <Link component={RouterLink} to="/about" color="inherit" display="block" sx={{ mb: 1.5, opacity: 0.9, '&:hover': { opacity: 1 } }}>
              About Us
            </Link>
            <Link component={RouterLink} to="/announcements" color="inherit" display="block" sx={{ mb: 1.5, opacity: 0.9, '&:hover': { opacity: 1 } }}>
              Announcements
            </Link>
            <Link component={RouterLink} to="/covenants" color="inherit" display="block" sx={{ mb: 1.5, opacity: 0.9, '&:hover': { opacity: 1 } }}>
              Covenants
            </Link>
            <Link component={RouterLink} to="/board-members" color="inherit" display="block" sx={{ opacity: 0.9, '&:hover': { opacity: 1 } }}>
              Board Members
            </Link>
            <Link component={RouterLink} to="/pay-hoa" color="inherit" display="block" sx={{ mt: 1.5, opacity: 0.9, '&:hover': { opacity: 1 } }}>
              Pay HOA Dues
            </Link>
            <Link component={RouterLink} to="/surveys" color="inherit" display="block" sx={{ mt: 1.5, opacity: 0.9, '&:hover': { opacity: 1 } }}>
              Surveys
            </Link>
            <Link component={RouterLink} to="/neighbor-businesses" color="inherit" display="block" sx={{ mt: 1.5, opacity: 0.9, '&:hover': { opacity: 1 } }}>
              Local Businesses
            </Link>
            <Link component={RouterLink} to="/real-estate-info" color="inherit" display="block" sx={{ mt: 1.5, opacity: 0.9, '&:hover': { opacity: 1 } }}>
              Real Estate Information
            </Link>
            <Link component={RouterLink} to="/contacts" color="inherit" display="block" sx={{ mt: 1.5, opacity: 0.9, '&:hover': { opacity: 1 } }}>
              Contact Us
            </Link>
          </Grid>
          
          <Grid item xs={12} sm={4}>
            <ContactCard inFooter={true} />
          </Grid>
        </Grid>
        
        <Divider sx={{ my: 4, bgcolor: 'rgba(255,255,255,0.2)' }} />
        
        <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography variant="body2" sx={{ opacity: 0.9, mb: { xs: 1, sm: 0 } }}>
            © {currentYear} Brynleigh Estates. All rights reserved.
          </Typography>
          <Box>
            <Link component={RouterLink} to="/privacy-policy" color="inherit" sx={{ mx: 1, fontSize: '0.875rem', opacity: 0.9, '&:hover': { opacity: 1 } }}>
              Privacy Policy
            </Link>
            <Link component={RouterLink} to="/terms" color="inherit" sx={{ mx: 1, fontSize: '0.875rem', opacity: 0.9, '&:hover': { opacity: 1 } }}>
              Terms of Use
            </Link>
            <Link href="https://OPSolutions.io" target="_blank" color="inherit" sx={{ mx: 1, fontSize: '0.875rem', opacity: 0.9, '&:hover': { opacity: 1 } }}>
              Powered by OP Solutions
            </Link>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;